import React, { useState } from 'react'
import { Button, Input, Label, Form, FormGroup, FormText, Spinner } from 'reactstrap'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import '../assets/scss/simpl.scss'

const validationSchema = Yup.object().shape({
  booking_code: Yup.string()
    .length(9, 'Die Buchungsnummer scheint nicht richtig zu sein. Überprüfen Sie bitte die Eingabe. Die Buchungsnummer ist 9-stellig')
    .required('Sie müssen eine Buchungsnummer angeben'),
  invoice_num: Yup.string()
      .matches(/^20[0-9]{2}-[0-9]{5}$/, 'Die Rechnungsnummer scheint nicht richtig zu sein. Überprüfen Sie bitte die Eingabe.')
      .required('Sie müssen eine Rechnungsnummer angeben'),
  // agreed: Yup.boolean()
  //   .oneOf([true], 'Stimmen Sie bitte den Umtauschbedingungen zu'),
})

const convertUrl = `${process.env.API_ENDPOINT}/vouchers/convert_tickets`

const formattedError = {
  'order already converted': 'Diese Tickets wurden bereits eingelöst',
  'order is unpaid': 'Diese Tickets wurden noch nicht bezahlt',
  'order not convertable': 'Die Kombination Rechnungs-/Buchungsnummer wurde nicht erkannt',
  'date allows no conversion': 'Für dieses Datum ist kein Einlösen von Tickets vorgesehen',
}

export default function SimplTicketExchange ({ setSucceeded }) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  // api POST submit
  const onSubmit = async values => {
    setLoading(true)
    setError(null)
    try {
      const res = await fetch(convertUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(values)
      })
      const jsonRes = await res.json()
      if (jsonRes.error) {
        setError(jsonRes.error)
        setLoading(false)
        return
      }
      if (jsonRes.code) {
        setSucceeded({ code: jsonRes.code, value: jsonRes.voucher.value })
      }
    } catch(e) {
      setLoading(false)
      console.error(e)
    }
  }

  const formik = useFormik({
    initialValues: {
      booking_code: '',
      invoice_num: '',
      org_id: 'org_5ee099fa245d1e00186ed1d3',
      // agreed: false,
    },
    validationSchema,
    onSubmit,
  })

  return (
    <div className="row">
      <div className="col">
        <h3 className="exchange-tickets">Tickets einlösen</h3>
        <Form className="simpl-form" onSubmit={formik.handleSubmit}>
          <FormGroup>
            <Label for="invoice_num">Rechnungsnummer</Label>
            {formik.errors.invoice_num && formik.touched.invoice_num
              && <FormText color="danger">{formik.errors.invoice_num}</FormText> }
            <Input
              type="text"
              id="invoice_num"
              name="invoice_num"
              disabled={loading}
              onChange={formik.handleChange}
              value={formik.values.invoice_num}
            />
            <FormText>z.B.: 2020-12345</FormText>
          </FormGroup>
          <FormGroup>
            <Label for="booking_code">Buchungsnummer</Label>
            {formik.errors.booking_code && formik.touched.booking_code
              && <FormText color="danger">{formik.errors.booking_code}</FormText> }
            <Input
              type="text"
              id="booking_code"
              name="booking_code"
              disabled={loading}
              onChange={formik.handleChange}
              value={formik.values.booking_code}
            />
            <FormText>z.B.: 123456789</FormText>
          </FormGroup>
          {/* <FormGroup check>
            {formik.errors.agreed && formik.submitCount > 0
              && <FormText color="danger">{formik.errors.agreed}</FormText> }
            <Label check>
              <Input
                name="agreed"
                disabled={loading}
                invalid={formik.errors.agreed}
                onChange={formik.handleChange}
                value={formik.values.agreed}
                type="checkbox"
              />
              <span className="form-check-sign" />
              <span>Ich bin mit den Bedingungen für den Umtausch einverstanden</span>
            </Label>
          </FormGroup> */}
          { error
            ? <div className="res-error alert alert-warning m-2">{formattedError[error]}</div>
            : null
          }
          <Button
            type="submit"
            color="danger"
            disabled={loading}
            block className="mt-4"
          >
            {loading
              ? <Spinner color="light" />
              : <span>Jetzt Einlösen</span>
            }
          </Button>
        </Form>
      </div>
      <div className="col">
        <div className="example-inv-desc">
          Wo finde ich diese Daten?
        </div>
        <div className="example-inv" />
      </div>
    </div>
  )
}